import { CSSProperties } from 'react';

import { HoverContentProps } from './hover-card.types';

import styles from './hover-card.module.css';

const HoverContent = ({ children, backgroundColor = 'transparent', backdropFilter }: HoverContentProps) => {
  return (
    <div
      className={`flex-column height-100-percent width-100-percent ${styles.hoverContent}`}
      data-component="HoverContent"
      style={
        {
          ...(backgroundColor && { '--hover-content-background-color': backgroundColor }),
          ...(backdropFilter && { '--hover-content-backdrop-filter': backdropFilter }),
        } as CSSProperties
      }
    >
      <>{children}</>
    </div>
  );
};

export default HoverContent;
